/**
 * Shared copy for the public marketing site. Compliance note: no sportsbook /
 * gambling language (peer-to-peer challenges, locked funds, settlement).
 */

export const NAV_LINKS = [
  { to: '/how-it-works', label: 'How It Works' },
  { to: '/features', label: 'Features' },
  { to: '/plus', label: 'Plus' },
  { to: '/safety', label: 'Safety' },
  { to: '/faq', label: 'FAQ' },
];

export const HOME_FEATURES = [
  {
    icon: '01',
    title: 'Browse by sport',
    body: 'Open any sport and swipe through upcoming matchups — the same live cards you use inside the app.',
  },
  {
    icon: '02',
    title: 'Lock It In',
    body: 'Pick a side, set your entry, and send a head-to-head challenge to a friend or the open arena.',
  },
  {
    icon: '03',
    title: 'Send a Ticket',
    body: 'Share a challenge link with someone who is not on LockedIn yet. Friends already in your list get an in-app challenge instead.',
  },
  {
    icon: '04',
    title: 'My Arena',
    body: 'Track active, open, and completed challenges in one place — always know what needs your attention.',
  },
  {
    icon: '05',
    title: 'Secure wallet',
    body: 'Fund with Stripe, keep entries in locked funds until settlement, and withdraw eligible balance when you are ready.',
  },
  {
    icon: '06',
    title: 'LockedIn Plus',
    body: 'Lower platform service fee, private leagues, and private chat for crews that compete together.',
  },
];

export const HOW_IT_WORKS_STEPS = [
  { step: '01', title: 'Create your account', body: 'Sign up free to claim your arena name. Guests can browse, but a free account is required to start real challenges.' },
  { step: '02', title: 'Add wallet funds', body: 'Deposit securely through Stripe. Wallet funds are used only for challenge entries — never mixed with your subscription.' },
  { step: '03', title: 'Pick a matchup', body: 'Choose a sport, find a game, and decide how you want to compete head-to-head.' },
  { step: '04', title: 'Send a challenge', body: 'Set your entry and invite a friend by link or username, or post an open challenge to the arena.' },
  { step: '05', title: 'Funds lock in', body: 'When a challenge is accepted, both entries move to locked funds until the result is settled.' },
  { step: '06', title: 'Settle the result', body: 'Live games settle from final scores. Custom challenges settle from the agreed outcome.' },
  { step: '07', title: 'Claim & withdraw', body: 'The winner reviews a clear transfer breakdown, claims earnings to their wallet, and can withdraw eligible balance.' },
];

export const SAFETY_POINTS = [
  { icon: '01', title: 'Powered by Stripe', body: 'Deposits and withdrawals run on Stripe — trusted payment infrastructure with bank-level safeguards.' },
  { icon: '02', title: 'Locked funds', body: 'Once both sides accept, entries stay locked until the result settles. Neither side can pull them early.' },
  { icon: '03', title: 'Clear settlement', body: 'Every challenge shows a transparent transfer breakdown. Platform fees are calculated server-side at settlement.' },
  { icon: '04', title: 'Full history', body: 'Every deposit, entry, refund, and transfer is logged in your wallet for complete transparency.' },
  { icon: '05', title: 'Bank withdrawals', body: 'Connect your bank through Stripe and move eligible available balance when you choose.' },
  { icon: '06', title: 'You stay in control', body: 'Manage your profile, funds, and withdrawals from inside the app at any time.' },
];

export const PLUS_BENEFITS = [
  { title: 'Reduced platform fee', body: 'Free members pay a 5% platform service fee on challenge earnings. LockedIn Plus members pay 2%.' },
  { title: 'Private leagues', body: 'Create private leagues for your crew and keep challenges inside your group.' },
  { title: 'Private chat', body: 'Unlock private chat to coordinate challenges directly with friends.' },
  { title: 'Premium features', body: 'Priority arena access and premium tools as the platform grows.' },
];

export const FAQS = [
  { q: 'What is LockedIn?', a: 'LockedIn is a peer-to-peer sports challenge platform. You create and accept head-to-head challenges with friends on the games you already follow — Lock It In or Send a Ticket from real matchup cards.' },
  { q: 'Is LockedIn a sportsbook?', a: 'No. There is no house and no odds board. You compete directly against another person. Accepted entries move to locked funds, and the result decides who claims the pool, minus a small platform service fee.' },
  { q: 'How do Lock It In and Send Ticket work?', a: 'Lock It In starts a head-to-head challenge from a matchup card — challenge a friend already on LockedIn from your friends list or the Lock It In chooser. Send Ticket shares a link for someone who is not on LockedIn yet so they can review and join.' },
  { q: 'How do the fees work?', a: 'Free members pay a 5% platform service fee on challenge earnings. LockedIn Plus members pay 2%. The fee is calculated by our servers at settlement.' },
  { q: 'How do deposits and withdrawals work?', a: 'Wallet funds are added and withdrawn through Stripe. Wallet balance is used for challenge entries and is separate from any subscription.' },
  { q: 'Can I browse without an account?', a: 'Yes — enter as guest to browse upcoming games and explore the app. A free account is required before starting real challenges.' },
  { q: 'What is the maximum challenge amount?', a: 'Challenges are capped at $500 per entry.' },
  { q: 'How are winners decided?', a: 'Live game challenges settle from final scores. Custom challenges settle from the outcome both players agreed to.' },
];

export const SPORT_TAGS = ['NBA', 'NFL', 'MLB', 'NHL', 'Soccer', 'MMA', 'Boxing', 'NCAA'];
